export type StatementFrequency = 'monthly';

export const STATEMENT_FREQUENCY: StatementFrequency = 'monthly';
export const STATEMENT_FREQUENCY_LABEL = 'Monthly';

export interface StatementEmailTemplate {
  id?: number;
  frequency: StatementFrequency;
  schedule_day: string | null;
  schedule_time: string;
  schedule_anchor_date: string | null; // ISO yyyy-mm-dd
  schedule_day_of_month: number | null; // 1–31
  subject: string;
  body: string;
}

export interface StatementConfig {
  location: string;
  sender_display_name: string;
  reply_to_email: string;
  sending_enabled: boolean;
  attach_invoices: boolean;
  include_residential: boolean;
  residential_client_count: number;
  email_template: StatementEmailTemplate | null;
}

export { MONTH_DAYS } from '../../config/model';

export const STATEMENT_TEMPLATE_VARIABLES = [
  { variable: '{{company_name}}', description: 'Company name' },
  { variable: '{{account_no}}', description: 'Customer account number' },
  { variable: '{{total_balance}}', description: 'Total outstanding balance' },
  { variable: '{{total_invoiced}}', description: 'Total invoiced amount' },
  { variable: '{{invoice_count}}', description: 'Number of outstanding line items' },
  {
    variable: '{{invoice_table}}',
    description: 'Outstanding line-item table (rendered as a styled table in the email)',
  },
];

// A blank template used when a location has no statement template yet (default template TBD).
export const BLANK_STATEMENT_TEMPLATE: StatementEmailTemplate = {
  frequency: 'monthly',
  schedule_day: null,
  schedule_time: '09:00',
  schedule_anchor_date: null,
  schedule_day_of_month: 1,
  subject: '',
  body: '',
};
